import { MimeType } from '~types';

const mapMimeTypeToExtension: Record<MimeType, string> = {
  [MimeType.IMAGE_JPEG]: 'jpeg',
  [MimeType.IMAGE_PNG]: 'png',
  [MimeType.IMAGE_WEBP]: 'webp',
};

export const formatMimeType = (mimeType: MimeType): string => mapMimeTypeToExtension[mimeType];
